'use client';

import clsx from 'clsx';
import Link from 'next/link';
import { ComponentProps, ReactNode } from 'react';

import { Text } from '../Text';
import styles from './NavLink.module.css';

interface NavLinkProps extends ComponentProps<typeof Link> {
  icons?: { inactive: ReactNode; active?: ReactNode };
  isActive?: boolean;
}

export const NavLink = ({
  className,
  children,
  icons,
  isActive,
  ...props
}: NavLinkProps) => {
  return (
    <Link
      className={clsx(styles.link, className)}
      data-active={isActive}
      {...props}
    >
      {isActive ? icons?.active || icons?.inactive : icons?.inactive}
      <Text
        className={styles.text}
        fontSize={13}
        fontWeight={400}
        lineHeight={20}
        letterSpacing={0.078}
        variant="secondary"
      >
        {children}
      </Text>
    </Link>
  );
};
